import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import FileInputField from "../../ui/form/FileInputField";
import InputField from "../../ui/form/InputField";
import Button from "../../ui/utils/Button";
import Alert from "../../ui/utils/Alert";
import usePost from "../../../hooks/api/usePost";
import apiRequest from "../../../utils/vendor/apiRequest";
import SelectField from "../../ui/form/SelectField";

const CreateGallery = ({ closeModal, callback }) => {
    const [preview, setPreview] = useState(null);

    const { error, isLoading, post, serverErrors } = usePost(
        apiRequest.createGallery
    );

    const formik = useFormik({
        initialValues: {
            type: "All",
            name: "",
            file: null,
        },

        validationSchema: Yup.object({
            type: Yup.string().required(),
            file: Yup.mixed().required("File is required"),
        }),

        onSubmit: async (values, { resetForm }) => {
            const formData = new FormData();
            formData.append("type", values.type);
            formData.append("name", values.name);
            formData.append("file", values.file);
            

            const response = await post({ data: { formData } });
            if (response?.response) {
                callback();
                resetForm();
                closeModal();
            }
        },
    });


    const types = ["All", "Image", "Video", "Document"];


    return (
        <div>
            <h2 className="p-4 text-lg font-semibold">Add Media</h2>
            <div className="border-b" />

            <form onSubmit={formik.handleSubmit} className="p-4 space-y-3 text-sm">
                {error && <Alert message={error} type="error" />}

                <SelectField
                    name="type"
                    label="Select Type"
                    value={formik.values.type}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    options={types?.map((c) => ({
                        value: c,
                        label: c,
                    }))}
                    error={formik.touched.type && formik.errors.type}
                    serverError={formik.serverErrors?.type}
                />


                <InputField
                    name="name"
                    label="Name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    serverError={serverErrors?.name}
                />

                <FileInputField
                    id="file"
                    label="Upload File"
                    accept="image/*,video/*"
                    error={formik.touched.file && formik.errors.file}
                    onChange={(e) => {
                        const file = e.currentTarget.files?.[0] || null;
                        formik.setFieldValue("file", file);
                        if (file) setPreview(URL.createObjectURL(file));
                    }}
                />

                {preview && (
                    <img src={preview} className="w-24 h-24 object-cover border rounded mt-2" />
                )}

                <div className="flex justify-end gap-2 mt-4">
                    <Button variant="secondary" onClick={closeModal}>
                        Cancel
                    </Button>

                    <Button variant="primary" isLoading={isLoading} loadingText="Creating...">
                        Create
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default CreateGallery;
